import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface LayoutUnauthenticatedProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function LayoutUnauthenticated({ title, subtitle, children }: LayoutUnauthenticatedProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: { xs: "100%", md: "50%" },
          minHeight: { xs: 120, md: "100%" },
          flex: { xs: "0 0 auto", md: "1 1 50%" },
          backgroundImage: {
            xs: "url(/assets/signin-banner-mobile.png)",
            md: "url(/assets/signin-banner-desktop.png)",
          },
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          px: 2,
          py: { xs: 2, md: 0 },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textShadow: "1px 1px 3px black",
            fontSize: {
              xs: "1.25rem",
              sm: "1.5rem",
              md: "2.125rem",
            },
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="h4"
            sx={{
              textShadow: "1px 1px 3px black",
              fontSize: {
                xs: "1.25rem",
                sm: "1.5rem",
                md: "2.125rem",
              },
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          flex: { xs: "1 1 auto", md: "1 1 50%" },
          px: { xs: 3, sm: 4, md: 4, xl: 20 },
          py: { xs: 3, md: 4 },
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "flex-start", md: "center" },
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "400px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}